import { Component, OnInit, Inject, OnDestroy, AfterViewInit } from '@angular/core';
import { InventoryService } from '@app/services/inventory/inventory.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { first, Subscription, take, takeUntil, takeWhile } from 'rxjs';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { selectCountsState } from '@app/modules/counts/store/selectors/counts.selectors';
import { Store } from '@ngrx/store';
import * as CountsActions from '@app/modules/counts/store/actions/counts.actions';
import { SubSink } from 'subsink';

@Component({
  selector: 'app-inventory-dialog',
  templateUrl: './inventory-dialog.component.html',
  styleUrls: ['./inventory-dialog.component.scss'],
  animations: []
})
export class InventoryDialogComponent implements OnInit, OnDestroy, AfterViewInit {
  public type$: string;
  public invID$: number;
  public subs: SubSink;
  
  public isLoadedSub$: Subscription
  public isLoading = false;
  
  constructor(
    private _inventory: InventoryService,
    private store$: Store,
    @Inject(MAT_DIALOG_DATA) public data
  ) { 

  }

  ngOnInit(): void {
    this.store$.select(selectCountsState).subscribe(res => {
      this.isLoading = res.isLoading;
    });
    this.store$.dispatch(CountsActions.setCurrentID({ currentId: this.data.invID }));
    this.store$.select(selectCountsState).subscribe(res => {
      this.type$ = res.currentType
    });
  }


  ngAfterViewInit(){

  }


  ngOnDestroy(){
    // this.subs.unsubscribe();
    // this.invSub$.unsubscribe();
  }



}
